



















































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import firebase from 'firebase/app';
import 'firebase/database';

@Component
export default class DatePicker extends Vue {
  @Prop() onRoundSelected!: (date: Date) => {};
  @Prop({ default: 'primary' }) color!: string;
  date = new Date().toISOString().substr(0, 10);
  dateFormatted = this.formatDate(this.date);
  datePicker = false;
  selectRound = false;
  selectedRound = 8;
  databaseRef?: firebase.database.Reference;
  onlineDayCount: { [key: string]: number } = {};
  offlineDayCount: { [key: string]: number } = {};
  roundOnlineCount: { [key: string]: number } = {};
  roundOfflineCount: { [key: string]: number } = {};
  morningDisabled = false;
  eveningDisabled = false;
  offlineTest = true;

  allowedDates = (val: string) => {
    const [year, month, date] = val.split('-');
    const index = this.dateArray.findIndex(
      o =>
        o.getFullYear() === +year &&
        o.getMonth() + 1 === +month &&
        o.getDate() === +date
    );
    if (this.offlineTest) {
      return (
        index > -1 &&
        (this.offlineDayCount[val] ? this.offlineDayCount[val] < 11 : true)
      );
    } else {
      return (
        index > -1 &&
        (this.onlineDayCount[val] ? this.onlineDayCount[val] < 11 : true)
      );
    }
  };

  @Watch('date')
  onDateChange(val: string) {
    this.dateFormatted = this.formatDate(val);
  }

  mounted() {
    this.databaseRef = firebase.database().ref('pr/reserve');
    this.databaseRef.on('value', snapshot => {
      const reservedObject = snapshot.val();
      Object.keys(reservedObject).forEach(k => {
        const testDate = new Date(reservedObject[k].testDate);
        if (reservedObject[k].isOnline) {
          this.roundOnlineCount[+testDate] =
            (this.roundOnlineCount[+testDate] || 0) + 1;
        } else {
          this.roundOfflineCount[+testDate] =
            (this.roundOfflineCount[+testDate] || 0) + 1;
        }
      });
      Object.keys(this.roundOnlineCount).forEach(k => {
        const date = new Date(+k);
        const key = `${date.getFullYear()}-${this.twoDigit(
          date.getMonth() + 1
        )}-${this.twoDigit(date.getDate())}`;
        this.onlineDayCount[key] =
          (this.onlineDayCount[key] || 0) + this.roundOnlineCount[k];
      });
      Object.keys(this.roundOfflineCount).forEach(k => {
        const date = new Date(+k);
        const key = `${date.getFullYear()}-${this.twoDigit(
          date.getMonth() + 1
        )}-${this.twoDigit(date.getDate())}`;
        this.offlineDayCount[key] =
          (this.offlineDayCount[key] || 0) + this.roundOfflineCount[k];
      });
    });
  }

  formatDate(dateIn: string) {
    const [year, month, day] = dateIn.split('-');
    return `${day}/${month}/${year}`;
  }

  twoDigit(num: number) {
    return ('00' + num).slice(-2);
  }

  checkRoundAvailable(data: string) {
    this.morningDisabled = false;
    this.eveningDisabled = false;
    const [year, month, date] = data.split('-');
    const selectDate = new Date(0);
    selectDate.setFullYear(+year, +month - 1, +date);
    if (this.offlineTest) {
      Object.keys(this.roundOfflineCount).forEach(k => {
        const keyDate = new Date(+k);
        if (
          keyDate.getFullYear() === selectDate.getFullYear() &&
          keyDate.getMonth() === selectDate.getMonth() &&
          keyDate.getDate() === selectDate.getDate()
        ) {
          if (keyDate.getHours() === 8) {
            this.morningDisabled = this.roundOfflineCount[k] > 9;
          }
          if (keyDate.getHours() === 13) {
            this.eveningDisabled = this.roundOfflineCount[k] > 9;
          }
        }
      });
      if (selectDate.getDay() === 0) {
        this.eveningDisabled = true;
      }
    } else {
      Object.keys(this.roundOnlineCount).forEach(k => {
        const keyDate = new Date(+k);
        if (
          keyDate.getFullYear() === selectDate.getFullYear() &&
          keyDate.getMonth() === selectDate.getMonth() &&
          keyDate.getDate() === selectDate.getDate()
        ) {
          if (keyDate.getHours() === 8) {
            this.morningDisabled = this.roundOnlineCount[k] > 9;
          }
          if (keyDate.getHours() === 13) {
            this.eveningDisabled = this.roundOnlineCount[k] > 9;
          }
        }
      });
    }
    this.selectRound = true;
  }

  submit() {
    const selectedDate = new Date(
      `${this.date}T${this.twoDigit(this.selectedRound - 7)}:00:00Z`
    );
    this.onRoundSelected(selectedDate);
  }

  get dateArray(): Date[] {
    const today = new Date();
    today.setMinutes(0, 0, 0);
    const res: Date[] = [];
    for (let i = 0; i < 8; i++) {
      today.setDate(
        today.getDate() + (today.getDay() === 6 ? 1 : 6 - today.getDay())
      );
      today.setHours(8);
      if (
        !(
          (today.getDate() === 26 &&
            today.getMonth() === 2 &&
            today.getFullYear() === 2022) ||
          (today.getDate() === 27 &&
            today.getMonth() === 2 &&
            today.getFullYear() === 2022)
        )
      ) {
        res.push(new Date(today));
      }
      // res.push(new Date(today));
      today.setHours(13);
      if (
        !(
          (today.getDate() === 26 &&
            today.getMonth() === 2 &&
            today.getFullYear() === 2022) ||
          (today.getDate() === 27 &&
            today.getMonth() === 2 &&
            today.getFullYear() === 2022)
        )
      ) {
        res.push(new Date(today));
      }
      // res.push(new Date(today));
    }
    return res;
  }
}
